import {
    Modal,
    Box,
    Typography,
    Grid,
    Chip,
    Button,
    Divider,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const formatText = (text = "") =>
    text
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase());

const JobDetailsModal = ({
    open,
    onClose,
    job,
    onApply,
}) => {
    if (!job) return null;



    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "95%", md: "85%" },
                    maxWidth: 1200,
                    maxHeight: "90vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                    bgcolor: "#fff",
                    borderRadius: 4,
                    boxShadow: 24,

                    // Hide scrollbar
                    scrollbarWidth: "none", // Firefox
                    msOverflowStyle: "none", // IE/Edge

                    "&::-webkit-scrollbar": {
                        display: "none", // Chrome/Safari
                    },
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 16,
                        right: 16,
                        zIndex: 2,
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* Header */}
                <Box
                    sx={{
                        p: 4,
                        background:
                            "linear-gradient(135deg, #0A4CAD 0%, #07329F 100%)",
                        color: "#fff",
                    }}
                >
                    <Typography variant="h4" fontWeight={700}>
                        {job?.title}
                    </Typography>

                    <Typography sx={{ mt: 1, opacity: 0.9 }}>
                        {job?.category?.name}
                    </Typography>

                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            flexWrap: "wrap",
                            mt: 2,
                        }}
                    >
                        <Chip
                            label={formatText(job.employmentType)}
                            sx={{ bgcolor: "#fff" }}
                        />
                        <Chip
                            label={formatText(job.workplaceType)}
                            sx={{ bgcolor: "#fff" }}
                        />
                        <Chip
                            label={formatText(job.experienceLevel)}
                            sx={{ bgcolor: "#fff" }}
                        />
                    </Box>
                </Box>
                <Box
                    sx={{
                        flex: 1,
                        overflowY: "auto",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",

                        "&::-webkit-scrollbar": {
                            display: "none",
                        },
                    }}
                >

                    <Grid container>
                        {/* Left Panel */}
                        <Grid item xs={12} md={4}>
                            <Box
                                sx={{
                                    p: 4,
                                    borderRight: {
                                        md: "1px solid #E5E7EB",
                                    },
                                    height: "100%",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    fontWeight={700}
                                    gutterBottom
                                >
                                    Job Summary
                                </Typography>

                                <Typography color="text.secondary">
                                    {job.shortDescription}
                                </Typography>

                                <Divider sx={{ my: 3 }} />

                                <Typography fontWeight={600}>
                                    Job Code
                                </Typography>

                                <Typography color="text.secondary">
                                    {job.jobCode}
                                </Typography>

                                <Divider sx={{ my: 2 }} />

                                <Typography fontWeight={600}>
                                    Open Positions
                                </Typography>

                                <Typography color="text.secondary">
                                    {job.openingsCount}
                                </Typography>

                                <Divider sx={{ my: 2 }} />

                                <Typography
                                    variant="h6"
                                    fontWeight={700}
                                    gutterBottom
                                >
                                    Skills
                                </Typography>

                                <Box
                                    sx={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 1,
                                    }}
                                >
                                    {job.skillsJson?.map((skill) => (
                                        <Chip
                                            key={skill}
                                            label={skill}
                                            color="primary"
                                            variant="outlined"
                                        />
                                    ))}
                                </Box>
                            </Box>
                        </Grid>

                        {/* Right Panel */}
                        <Grid item xs={12} md={8}>
                            <Box sx={{ p: 4 }}>
                                {[
                                    "overview",
                                    "responsibilities",
                                    "requirements",
                                    "goodToHave",
                                    "benefits",
                                ].map((section) =>
                                    job.jdJson?.[section] ? (
                                        <Box
                                            key={section}
                                            sx={{ mb: 4 }}
                                            dangerouslySetInnerHTML={{
                                                __html: job.jdJson[section],
                                            }}
                                        />
                                    ) : null
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                {/* Footer */}
                <Box
                    sx={{
                        position: "sticky",
                        bottom: 0,
                        bgcolor: "#fff",
                        p: 3,
                        borderTop: "1px solid #E5E7EB",
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                    <Button
                        variant="contained"
                        size="large"
                        onClick={() => onApply(job)}
                        sx={{
                            bgcolor: "#0A4CAD",
                            px: 5,
                            borderRadius: 2,
                            textTransform: "none",
                        }}
                    >
                        Apply Now
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default JobDetailsModal;